"use server"

import { ambilSesiAkun } from "@/modules/akun/service/sesi-akun"
import { PESAN_BATAS_PERCOBAAN } from "@/modules/akun/domain/batas-laju-akun"
import { buatPembatasLaju } from "@/modules/help/domain/batas-laju"
import { ambilKonfigWebPush, daftarkanPerangkat, lepasPerangkat, lepasToken, pushSiap } from "@/modules/push/service/fcm"
import type { KonfigWebPush } from "@/modules/push/domain/push"
import type { HasilAksi, HasilData } from "@/modules/akun/domain/tipe"

const izinkanAturPush = buatPembatasLaju(20, 10 * 60_000)
const PESAN_SESI_BERAKHIR = "Sesi berakhir. Masuk lagi untuk melanjutkan."

export async function ambilKonfigPush(): Promise<KonfigWebPush | null> {
  const sesi = await ambilSesiAkun()
  return sesi && pushSiap() ? ambilKonfigWebPush() : null
}

export async function aktifkanPushPerangkat(masukan: { token: string; nama: string }): Promise<HasilAksi> {
  const sesi = await ambilSesiAkun()
  if (!sesi) return { ok: false, pesan: PESAN_SESI_BERAKHIR }
  if (!izinkanAturPush(sesi.akunId)) return { ok: false, pesan: PESAN_BATAS_PERCOBAAN }
  try {
    return await daftarkanPerangkat(sesi.akunId, masukan)
  } catch (error) {
    console.error("Gagal mendaftarkan perangkat push:", error)
    return { ok: false, pesan: "Perangkat belum bisa didaftarkan. Coba lagi sebentar." }
  }
}

export async function nonaktifkanPushToken(token: string): Promise<HasilAksi> {
  const sesi = await ambilSesiAkun()
  if (!sesi) return { ok: false, pesan: PESAN_SESI_BERAKHIR }
  return lepasToken(sesi.akunId, token)
}

export async function hapusPerangkatPush(id: string): Promise<HasilData<null>> {
  const sesi = await ambilSesiAkun()
  if (!sesi) return { ok: false, pesan: PESAN_SESI_BERAKHIR }
  const hasil = await lepasPerangkat(sesi.akunId, id)
  return hasil.ok ? { ok: true, data: null } : hasil
}
